export default "__VITE_ASSET__Djj53E$0__"